import { t } from '@gem/modules/i18n';
import { media } from '@gem/modules/permissions';

import Tasks from 'APP/Tasks';

export const getVideoPermission = async (deviceId?: string, withAlert = true): Promise<boolean> => {
  const hasVideoPermission = await media.getVideoPermission(deviceId);

  if (!hasVideoPermission && withAlert) {
    Tasks.app.showAlert(t('calls_no_camera_permissions'));
  } else if (!hasVideoPermission) {
    return false;
  }

  return true;
};
